/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Блок заказа акта сверки
   */
  app.ActOfReconciliationView = app.FormView.extend({
    formName: 'legal-entity-act',
    el: '.popup-act-of-reconciliation',
    additionalOptions: ['collection', 'faderView', 'opener', 'userId', 'bodyView', 'isMobile'],
    uploadOptions: {
      urlRoot: '/api/v3/reconciliation-act-request/'
    },
    events: {
      'click .js-send-act-reconciliation': 'submit',
      'input #legal-entity-act-name': 'validationInput',
    },

    /**
     * @inheritDoc
     */
    run: function () {
      this.childViews.datapicker = new app.DatepickerView({ dateFormat: 'dd-mm-yy' });
      this.$('.input-datepicker-from').datepicker();
      this.$('.input-datepicker-to').datepicker();
      this.initSuggestions();
      this.initPopup();
      this.initSuccessMessagePopup();
      this.listenTo(Backbone, 'open-act-of-reconciliation-popup', this.openPopup);
      app.FormView.prototype.run.apply(this, arguments);
    },

    /**
     * Инициализация попапа
     */
    initPopup: function () {
      if (!this.isMobile) {
        this.popup = new als.Popup(
          this.$el,
          this.opener,
          null, null,
          this.childViews.datapicker.getDpElement()
        );
      } else {
        this.childViews.popupView = new app.MobilePopupFillView({
          el: this.el,
          $opener: this.opener,
          bodyView: this.bodyView,
          $excludeExternalClickElement: this.childViews.datapicker.getDpElement(),
        });
        this.popup = this.childViews.popupView.popup;
      }
      this.popup.addEventListener(als.Popup.EventType.BEFORE_OPEN, this.clearErrors.bind(this));
      if (this.collection) {
        this.popup.addEventListener(als.Popup.EventType.BEFORE_OPEN, this.getLegalEntity.bind(this));
      }
      if (!this.isMobile) {
        this.popup.addEventListener(als.Popup.EventType.BEFORE_OPEN, this.handlePopupOpen.bind(this));
        this.popup.addEventListener(als.Popup.EventType.BEFORE_CLOSE, this.handlePopupClose.bind(this));
      }
    },

    /**
     * Инициализация попапа успешной отправки формы.
     */
    initSuccessMessagePopup: function () {
      this.formSuccessMessageTemplate = app.helpers.TemplateHelper.getTemplate('#form-success-message-template');
      var $formSuccessMessage = $(this.formSuccessMessageTemplate());
      if (!this.isMobile) {
        $formSuccessMessage.css({
          position: 'fixed',
          bottom: 80,
          right: 130,
        });
      }
      this.$el.after($formSuccessMessage);
      this.childViews.formSuccessPopup = new als.Popup($formSuccessMessage);
    },

    /**
     * Выполняется перед открытием попапа
     */
    handlePopupOpen: function () {
      this.faderView.show();
      app.helpers.PopupPositioningHelper.positionCenterOfWindow(this.$el);
    },

    /**
     * Выполняется перед закрытием попапа
     */
    handlePopupClose: function () {
      this.faderView.hide();
    },

    /**
     * Открытие попапа
     * @param {Event} e
     */
    openPopup: function (e) {
      this.popup.opener_ = $(e.currentTarget);
      if (this.popup.closed_) {
        this.popup.open($(e.currentTarget));
      }
    },

    /**
     * Инициализация подсказок DaData
     */
    initSuggestions: function () {
      var that = this;
      this.$('#legal-entity-act-name').suggestions(app.helpers.DaDataHelper.getSuggestionsConfig({
        type: 'PARTY',
        count: 5,
        onSelect: function(ev) {
          that.onSelect(ev);
        }
      }));
    },

    /**
     * Инициализация текущего Юр лица
     * @param {Event} event
     * @param {Object} opener
     */
    getLegalEntity: function(event, opener) {
      opener = $(opener.target);
      var id = opener.parent().data('counterparty-id') || opener.parent().data('legal-entity-id'),
        legalEntity = this.collection.get(id);
      if (!legalEntity) {
        return;
      }

      var name = legalEntity.get('name');
      this.$('.field').val('').prop('checked', false);
      this.$('#legal-entity-act-name').val(name);
      this.currentLegalEntity = {
        name: name,
        inn: legalEntity.get('inn'),
      };
    },

    /**
     * Выбрали Юр. лицо из списка Dadata
     * @param {Object} ev событие с данными из Dadata
     */
    onSelect: function (ev) {
      this.currentLegalEntity = {
        name: ev.value,
        inn: ev.data.inn,
      };
    },

     /**
     * Отправить запрос
     */
    submit: function (e) {
      e.preventDefault();
      this.model = new app.Model();
      this.model.urlRoot = app.entryScriptName + '/api/v3/reconciliation-act-request';
      var data = this.getData();
      if (this.currentLegalEntity && data.name === this.currentLegalEntity.name) {
        data.inn = this.currentLegalEntity.inn;
      }
      data.user_id = this.userId;
      this.$('.js-send-act-reconciliation').prop('disabled', true);
      this.listenTo(this.model, 'sync', this.success);
      this.listenTo(this.model, 'error', this.error);
      this.model.save(data);
    },

    /**
     * Ошибка отправки
     * @private
     */
    error: function () {
      this.$('.js-send-act-reconciliation').prop('disabled', false);
      app.FormView.prototype.error.apply(this, arguments);
    },

    /**
     * Сообщение отправлено удачно
     * @private
     */
    success: function () {
      this.popup.close();
      app.FormView.prototype.success.apply(this);
      this.$('.js-send-act-reconciliation').prop('disabled', false);
      this.childViews.formSuccessPopup.open();
    },

    /**
     * Вызывает функцию для валидации ввода символов
     * @param {Event} e Событие input
     */
    validationInput: function (e) {
      app.helpers.InputHelper.handleFieldInput(e, 'text');
    }
  });
})(jQuery);

}.call(window));